import { useContext, useEffect } from 'react';
import { useSnackbar } from 'notistack';

import { Project } from '../types';
import { DasLockTaskGroupEvent } from '../types/Announcement';
import { Equipment } from '../types/Resource';

import { getProjectEquipments } from '../apis/ProjectApi';

import { PubSubContext } from '../utils/PubSub';

type UseUnlockRequestProps = {
  project: Project | null;
};

const useUnlockRequest = ({ project }: UseUnlockRequestProps) => {
  const pubSub = useContext(PubSubContext);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (pubSub === null) {
      return;
    }

    const handleUnlockRequest = async (event: DasLockTaskGroupEvent) => {
      let equipment: Equipment | undefined;

      if (!project) return;

      const isInAccountPage = window.location.pathname.includes('/account/');

      if (
        event.endpoint.metadata['dsm/projectId'] === project.id &&
        !isInAccountPage
      ) {
        if (event.status === 'allPending') {
          if (event.endpoint.metadata['dsm/equipmentId']) {
            const response = await getProjectEquipments({
              projectId: project.id,
              params: {
                id: event.endpoint.metadata['dsm/equipmentId'],
              },
            });
            for (const eq of response.data.data) {
              if (eq.id === event.endpoint.metadata['dsm/equipmentId']) {
                equipment = eq;
                break;
              }
            }
          }
          const key = `unlock-request-${event.endpoint.id}-${event.endpoint.shadow.dataPoint.timestamp.value}`;
          enqueueSnackbar('unlockRequest', {
            key,
            variant: 'unlockRequest',
            project: {
              id: project.id,
              name: project.name,
            },
            equipmentName: equipment?.name,
            dasId: event.endpoint.dasId,
          });
        }
      }
    };

    pubSub.subscribe('task-group-status', handleUnlockRequest);

    return () => {
      pubSub.unsubscribe('task-group-status', handleUnlockRequest);
    };
  }, [project]);
};

export default useUnlockRequest;
